import WbHttpClient from './wbhttpclient';

export default class TeamServices {
  constructor() {
    this.WbHttpClient = new WbHttpClient();
  }

  getTeamUserDetails(params = {}) {
    return this.WbHttpClient.post('team/getTeamUserDetails', params);
  }

  getMydirectAndDoted(params = {}) {
    return this.WbHttpClient.post('team/getMydirectAndDoted', params);
  }

  getVelocityRank(params = {}) {
    return this.WbHttpClient.get('activity/getVelocityRank', params);
  }
}
